import React, { useCallback, useEffect, useState } from "react";
import { Grid, Box, Button } from '@mui/material';
import AxiosInstance from "../../../server/AxioInstance";
import SelectAutoComplete from "../../common/autoComplete/SelectAutoComplete";
import MultiSelectAutocomplete from "../../common/autoComplete/MultiSelectAutocomplete";
import { useSnackbar } from '../../../shared/context';


const LinkSectorUserCreate = ({ handleChangeComponent }) => {
    const [getOptionsUser, setOptionsUser] = useState([]);
    const [getOptionsSector, setOptionsSector] = useState([]);
    const [getOptionsLinkSector, setOptionsLinkSector] = useState([]);
    const { showSnackbar } = useSnackbar();
    const [getFormData, setFormData] = useState({
        user: [],
        sector: [],
        linkSector: []
    });
    
    const handleReturnComponent = () => {
        handleChangeComponent('Consultar vínculo de setor com usuário','consult');
    };

    const handleChangeUser = (e, value) => {
        setFormData((prevData) => ({ ...prevData, user: value }));
    };

    const handleChangeSector = (e, value) => {
        setFormData((prevData) => ({ ...prevData, sector: value }));
        getSector(value);
    };

    const handleChangeSubSector = (e, value) => {
        setFormData((prevData) => ({ ...prevData, linkSector: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault(); 

        const formDataToSend = new FormData();
        formDataToSend.append('login', localStorage.getItem('@gedy:user'));
        formDataToSend.append('user', JSON.stringify(getFormData.user));
        formDataToSend.append('sector', JSON.stringify(getFormData.sector));
        formDataToSend.append('linkSector', JSON.stringify(getFormData.linkSector));

        try {
            await AxiosInstance.post('/sector/link-sectors-user', formDataToSend, { headers: { "Content-Type": "multipart/form-data" } });
            showSnackbar({
                vertical: 'top',
                horizontal: 'right',
                message: 'Criado com Sucesso',
                variant: 'success',
            });
            handleReturnComponent();
        } catch (error) {
            showSnackbar({
                vertical: 'top',
                horizontal: 'right',
                message: 'Erro ao enviar a requisição: ' + error.message,
                variant: 'error',
            });
        }
    }

    const handleGetSector = useCallback( async () => {
        const result = await AxiosInstance.get('/sector/consult-macro-sectors');
        
        const transformedData = await result.data.rows.map(item => ({
            id: item.id,
            value: item.description
        }));
        
        setOptionsSector(transformedData);
    }, []);

    const handleGetUser = useCallback( async () => {
        const result = await AxiosInstance.get('/data-input/users');
        setOptionsUser(result.data);
    }, []);

    const getSector = useCallback( async (value) => {
        try {
            const result = await AxiosInstance.post('/data-input/sector', [value]);
            setOptionsLinkSector(result.data);
        } catch (error) {
            console.error('Erro ao pegar dados a requisição:', error);
        }
        // eslint-disable-next-line
    }, [getFormData.macroSector]);

    useEffect( ()=>{
        handleGetSector();
        handleGetUser();
    }, [handleGetSector, handleGetUser])

    return(
        <Box m={1}>
            <form onSubmit={handleSubmit} method='POST'>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={12} xl={12}>
                        <SelectAutoComplete 
                            name='user'
                            value={getFormData.user}
                            options={getOptionsUser} 
                            label='Selecione o Funcionário'
                            onChange={(event, selectValues) => handleChangeUser(event, selectValues)}
                            required={false}
                        />
                    </Grid>
                    <Grid item xs={12} md={12} xl={12}>
                        <SelectAutoComplete 
                            name='sector'
                            value={getFormData.sector}
                            options={getOptionsSector} 
                            label='Selecione o Setor'
                            onChange={(event, selectValues) => handleChangeSector(event, selectValues)}
                            required={false}
                        />
                    </Grid>
                    <Grid item xs={12} md={12} xl={12}>
                        <MultiSelectAutocomplete 
                            name='subSector'
                            value={getFormData.linkSector}
                            options={getOptionsLinkSector} 
                            label='Selecione os Sub-Setores'
                            onChange={(event, selectValues) => handleChangeSubSector(event, selectValues)}
                            required={false}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} xl={6}>
                        <Button 
                            variant='contained' 
                            color="primary"
                            onClick={handleReturnComponent}
                            fullWidth
                        >
                            voltar
                        </Button>
                    </Grid>
                    <Grid item xs={12} md={6} xl={6}>
                        <Button 
                            type='submit'  // Adicionando o tipo submit ao botão
                            variant='contained' 
                            color="success"
                            fullWidth
                        >
                                Vincular
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </Box>
    )
}

export default LinkSectorUserCreate;